
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {IRouteStartingLocation} from '@/model/Route/routeInterfaces';
import RouteLocationPickerMap, {IPickerLocation} from '@/components/route/RouteLocationPickerMap.vue';

const routeModule = namespace('routeModule');

@Component({components: {RouteLocationPickerMap}})
export default class RouteStartingLocationDialog extends Vue {
  @Prop({default: false}) protected value!: boolean;
  @Prop({default: null})  protected selectedId!: number | null;

  @routeModule.Getter('startingLocations') protected startingLocations!: IRouteStartingLocation[];
  @routeModule.Getter('mapsApiKey')        protected mapsApiKey!: string;
  @routeModule.Action('createStartingLocation') protected createStartingLocation!: (data: any) => any;
  @routeModule.Action('deleteStartingLocation') protected deleteStartingLocation!: (id: number) => any;
  @routeModule.Action('fetchStartingLocations') protected fetchStartingLocations!: () => any;

  protected showForm: boolean  = false;
  protected saving: boolean    = false;
  protected deletingId: number | null = null;
  protected deleteDialog: boolean     = false;
  protected pendingDelete: IRouteStartingLocation | null = null;
  protected formError: string = '';

  protected form = {
    name:    '',
    address: '',
    lat:     0,
    lng:     0,
  };

  protected get internalOpen(): boolean {
    return this.value;
  }

  protected set internalOpen(val: boolean) {
    this.$emit('input', val);
  }

  protected get canSaveForm(): boolean {
    return !!this.form.name && !!this.form.address && this.form.lat !== 0;
  }

  @Watch('value')
  protected onValueChanged(val: boolean) {
    if (!val) {
      this.closeForm();
    }
  }

  protected onMapChange(loc: IPickerLocation) {
    this.form.lat     = loc.lat;
    this.form.lng     = loc.lng;
    this.form.address = loc.address;
  }

  protected select(loc: IRouteStartingLocation) {
    this.$emit('select', loc);
    this.internalOpen = false;
  }

  protected openForm() {
    this.showForm  = true;
    this.formError = '';
    this.form      = {name: '', address: '', lat: 0, lng: 0};
  }

  protected closeForm() {
    this.showForm = false;
  }

  protected async saveLocation() {
    if (!this.canSaveForm) { return; }
    this.saving    = true;
    this.formError = '';

    try {
      await this.createStartingLocation({
        name:    this.form.name,
        address: this.form.address,
        lat:     this.form.lat,
        lng:     this.form.lng,
      });
      this.closeForm();
    } catch (e) {
      this.formError = this.$t('common.errorHappened') as string;
    } finally {
      this.saving = false;
    }
  }

  protected confirmDelete(loc: IRouteStartingLocation) {
    this.pendingDelete = loc;
    this.deleteDialog  = true;
  }

  protected async doDelete() {
    if (!this.pendingDelete) { return; }
    const id = this.pendingDelete.id;
    this.deletingId   = id;
    this.deleteDialog = false;

    try {
      await this.deleteStartingLocation(id);
      await this.fetchStartingLocations();
    } finally {
      this.deletingId    = null;
      this.pendingDelete = null;
    }
  }
}
